import { Component, inject } from '@angular/core';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { HowdenAuthService } from '@howdeniberia/core-front';
import { UserRole } from 'src/app/core/enums';

@Component({
  selector: 'howden-cookie-delete',
  templateUrl: './cookie-delete.component.html',
  styleUrls: ['./cookie-delete.component.scss'],
  imports: [MatSidenavContainer, MatToolbar, MatToolbarRow]
})
export class CookieDeleteComponent {
  private router = inject(Router);
  private authSrv = inject(HowdenAuthService);

  returnToRiskMap() {
    if (this.authSrv.isSuperAdmin || this.authSrv.isUserAuthorized([UserRole.Admin, UserRole.Manager])) {
      this.router.navigate(['management/home']);
    } else if (this.authSrv.isUserAuthorized([UserRole.Basic])) {
      this.router.navigate(['/home']);
    }
  }
}
